import { render, staticRenderFns } from "./VacancyCandidatesKanbanStageDelete.vue?vue&type=template&id=315b9840&scoped=true&"
import script from "./VacancyCandidatesKanbanStageDelete.vue?vue&type=script&lang=js&"
export * from "./VacancyCandidatesKanbanStageDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b9840",
  null
  
)

/* custom blocks */
import block0 from "./VacancyCandidatesKanbanStageDelete.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyCandidatesKanbanStageDelete.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCardTitle,VDialog,VSelect})
